<template>
    <h1
        :class="['SearchHeading', { 'isLoading': loading }]"
        v-skeleton="{
            loading,
            sizes: {
                Small: { width: '100%', height: '2rem' },
                ExtraLarge: { width: '100%', height: '2rem' },
            }
        }"
    >{{ searchStore.pageTitle }}</h1>
    <p
        v-if="isRanking"
        class="SearchSubHeading"
        v-skeleton="{
            loading,
            sizes: {
                Small: { width: '100%', height: '2rem' },
                ExtraLarge: { width: '100%', height: '2rem' },
            }
        }"
    >Studyportals Meta Ranking, combining the world's leading rankings</p>
</template>


<script setup lang="ts">
import { computed } from 'vue';
import { useSearchStore } from '@app/stores/useSearchStore';
import { FilterType } from '@studyportals/omnisearch-interfaces';
import { OrganisationSortType } from "@studyportals/search-api-interface";

const searchStore = useSearchStore();

const loading = computed(() => searchStore.loading);
const isRanking = computed(() => searchStore.filtersSelection?.find(filter => filter.type === FilterType.SORTING)?.values[0]?.id === OrganisationSortType.RANKINGS);
</script>

<style scoped lang="scss">
    h1.SearchHeading {
            color: $Grey-900;

            @include TextStyle(HeadingSmall);

            @include Breakpoint(Medium, Large, ExtraLarge) {
                @include TextStyle(HeadingMedium);
            }

            margin: 0.25em 0 !important;
        }
    p.SearchSubHeading {
            color: $Grey-700;

            @include TextStyle(BodyMediumRegular);
            @include MarginAreas(0, 0, 0.5, 0);

            @include Breakpoint(Large, ExtraLarge) {
                @include TextStyle(BodyRegular);
                @include MarginAreas(0.25, 0, 0.5, 0);
            }
        }
</style>